import React from 'react';
import { Check, FileText, Loader2, Trash } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface Props {
  searchRef: React.RefObject<HTMLDivElement | null>;
  renderSearch?: () => React.ReactNode;
  onNew?: () => void;
  onSave?: () => void;
  onDelete?: () => void;
  newDisabled: boolean;
  saveDisabled: boolean;
  deleteDisabled: boolean;
  newTitle: string;
  saveTitle: string;
  deleteTitle: string;
  isSaving: boolean;
}

const buttonClass = `flex h-8 w-8 items-center justify-center rounded-md border border-gray-300
  bg-white text-gray-700 shadow-sm transition-colors hover:bg-gray-50 hover:border-gray-400
  focus:outline-none focus:ring-2 focus:ring-blue-500/50 disabled:cursor-not-allowed
  disabled:border-gray-200 disabled:bg-gray-50 disabled:text-gray-300`;

const GenericMasterHeaderCompactActions: React.FC<Props> = ({
  searchRef, renderSearch, onNew, onSave, onDelete, newDisabled, saveDisabled, deleteDisabled,
  newTitle, saveTitle, deleteTitle, isSaving,
}) => {
  const { t } = useTranslation();

  return (
    <div className="flex h-8 items-center gap-2">
      {renderSearch && (
        <div ref={searchRef} data-header-search-focus="true" className="min-w-0">
          {renderSearch()}
        </div>
      )}
      <div className="flex shrink-0 items-center gap-1">
        {onNew && (
          <button type="button" onClick={onNew} disabled={newDisabled} title={newTitle} className={buttonClass}>
            <FileText size={14} />
          </button>
        )}
        {onSave && (
          <button type="button" onClick={onSave} disabled={saveDisabled} title={saveTitle} className={buttonClass}>
            {isSaving ? <Loader2 size={14} className="animate-spin" /> : <Check size={14} />}
          </button>
        )}
        {onDelete && (
          <button
            type="button"
            onClick={onDelete}
            disabled={deleteDisabled}
            title={deleteTitle || t('buttons.delete')}
            className={`${buttonClass} enabled:hover:text-red-700`}
          >
            <Trash size={14} />
          </button>
        )}
      </div>
    </div>
  );
};

export default GenericMasterHeaderCompactActions;
